export const CATEGORICAL_COLOR_VARIABLES = [
  "--chart-categorical-1-subtle",
  "--chart-categorical-2-subtle",
  "--chart-categorical-3-subtle",
  "--chart-categorical-4-subtle",
  "--chart-categorical-5-subtle",
  "--chart-categorical-6-subtle",
  "--chart-categorical-7-subtle",
  "--chart-categorical-8-subtle",
  "--chart-categorical-1-subtler",
  "--chart-categorical-2-subtler",
  "--chart-categorical-3-subtler",
  "--chart-categorical-4-subtler",
  "--chart-categorical-5-subtler",
  "--chart-categorical-6-subtler",
  "--chart-categorical-7-subtler",
  "--chart-categorical-8-subtler",
];
